import { Link } from "react-router-dom"
import { Col, Row } from "reactstrap"

export const PageSubHeader = ({ heading, routePath, pageName }) => {
    return <Row className="subheader" >
        <Col className="col-3">
            <div className="d-flex align-items-center">
                <div>
                    <h5 className="subheader-text">{heading}</h5>
                </div>
                <div className="subheader-tabs">
                </div>
            </div>
        </Col>
        <Col className="col-7"></Col>
        <Col className="col-2 d-flex justify-content-end text-nowrap">
            <div>
                <Link to="/dashboard">{routePath}</Link>
                {" "} / {" "}
                <span>{pageName}</span>
            </div>
        </Col>
    </Row>
}